import jwtDecode from 'jwt-decode';
import axios from 'axios';
import config from '../../config';


// content type
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.defaults.baseURL = config.API_URL;

// intercepting to capture errors
// axios.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     // Any status codes that falls outside the range of 2xx cause this function to trigger
//     let message;

//     if (error && error.response && error.response.status === 404) {
//       // window.location.href = '/not-found';
//     } else if (error && error.response && error.response.status === 403) {
//       window.location.href = '/access-denied';
//     } else {
//       switch (error.response.status) {
//         case 401:
//           message = 'Invalid credentials';
//           break;
//         case 403:
//           message = 'Access Forbidden';
//           break;
//         case 404:
//           message = 'Sorry! the data you are looking for could not be found';
//           break;
//         default: {
//           message =
//             error.response && error.response.data ? error.response.data['message'] : error.message || error;
//         }
//       }
//       return Promise.reject(message);
//     }
//   }
// );

const USER_SESSION = 'user';

/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: string | null) => {
  if (token) {
    axios.defaults.headers.common['X-Auth-Token'] = token;
  } else {
    delete axios.defaults.headers.common['Authorization'];
    delete axios.defaults.headers.common['X-Auth-Token'];
  }
};

const getUserFromSession = () => {
  const user = localStorage.getItem(USER_SESSION);
  return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

/*
Check if token available in session
*/
let user = getUserFromSession();
if (user) {
  const { token } = user;
  if (token) {
    setAuthorization(token);
  }
}

class APICore {
  /**
   * Fetches data from given url
   */
  get = (url: string, params: any) => {
    let response;
    if (params) {
      var queryString = params
        ? Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')
        : '';
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }
    return response;
  };

  getFile = (url: string, params: any) => {
    let response;
    if (params) {
      var queryString = params
        ? Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')
        : '';
      response = axios.get(`${url}?${queryString}`, { responseType: 'blob' });
    } else {
      response = axios.get(`${url}`, { responseType: 'blob' });
    }
    return response;
  };

  getMultiple = (urls: string, params: any) => {
    const reqs = [];
    let queryString = '';
    if (params) {
      queryString = params
        ? Object.keys(params)
          .map((key) => key + '=' + params[key])
          .join('&')
        : '';
    }

    for (const url of urls) {
      reqs.push(axios.get(`${url}?${queryString}`));
    }
    return axios.all(reqs);
  };

  /**
   * post given data to url
   */
  create = (url: string, data: any) => {
    return axios.post(url, data);
  };

  /**
   * Updates patch data
   */
  updatePatch = (url: string, data: any) => {
    return axios.patch(url, data);
  };

  /**
   * Updates data
   */
  update = (url: string, data: any) => {
    return axios.put(url, data);
  };

  /**
   * Deletes data
   */
  delete = (url: string) => {
    return axios.delete(url);
  };

  /**
   * post given data to url with file
   */
  createWithFile = (url: string, data: any) => {
    const formData = new FormData();
    for (const k in data) {
      formData.append(k, data[k]);
    }

    const config: any = {
      headers: {
        ...axios.defaults.headers,
        'content-type': 'multipart/form-data',
      },
    };
    return axios.post(url, formData, config);
  };

  /**
   * post given data to url with file
   */
  updateWithFile = (url: string, data: any) => {
    const formData = new FormData();
    for (const k in data) {
      formData.append(k, data[k]);
    }

    const config: any = {
      headers: {
        ...axios.defaults.headers,
        'content-type': 'multipart/form-data',
      },
    };
    return axios.patch(url, formData, config);
  };


  isUserAuthenticated = () => {
    const user = this.getLoggedInUser();

    if (!user || user.auth_token == null) {
      return false;
    } else {
      return true;
    }
  };

  setLoggedInUser = (user: any) => {
    if (user) {
      localStorage.setItem(USER_SESSION, JSON.stringify(user));
    } else {
      localStorage.removeItem(USER_SESSION);
    }
  };

  /**
   * Returns the logged in user
   */
  getLoggedInUser = () => {
    return getUserFromSession();
  };

  setUserInSession = (modifiedUser: any) => {
    let userInfo = localStorage.getItem(USER_SESSION);
    if (userInfo) {
      const { token, user } = JSON.parse(userInfo);
      this.setLoggedInUser({ token, ...user, ...modifiedUser });
    }
  };

  /* Assuming if the primary color is set, then there is a tenant set */
  isTenantSet = () => {
    let tenant = localStorage.getItem("FleetPortalCustomization");
    if (tenant && tenant !== "undefined" && tenant !== "null") {
      return true
    }
    return false;
  }

}


export { APICore, setAuthorization };
